import { ComplexValue } from 'app/types-shared';

export const addToArrayIfNotAlreadyThere = (group: ComplexValue<number>[], newValue: ComplexValue<number>) => {
  if (newValue && !(group && group.some(o => o.value === newValue.value))) {
    return [
      ...(group || []),
      newValue
    ];
  }
  else {
    return group;
  }
};

export const groupSelectorFieldName = (formName: string, groupingName: string) => `${formName}-${groupingName}_id`;

export const updateSelectedValues = (initialValue, groupingName: string, valueName: string) => {
  return (initialValue && initialValue.reduce((memo, current) => {
    const newValue = {
      value: current[valueName].v,
      description: current[valueName].d
    };
    const newPanelValue = {
      [current[groupingName].v]: [
        ...(memo[current[groupingName].v] || []),
        newValue
      ]
    };

    return { ...memo, ...newPanelValue };
  }, {})
  );
};

export const addSelectedValues = (
  prevSelectedValues: { [key: number]: ComplexValue<number>[] },
  selectedGroupKey: number,
  selectedValues: ComplexValue<number>[]
) => {

  const prevGroup = (prevSelectedValues && prevSelectedValues[selectedGroupKey]) || [];
  const currentGroup = selectedValues
    ? selectedValues.filter(v => !prevGroup || !prevGroup.some(pv => pv.value === v.value))
    : [];

  if (currentGroup.length > 0) {
    return {
      ...prevSelectedValues,
      [selectedGroupKey]: [
        ...prevGroup,
        ...currentGroup
      ]
    };
  }

  return prevSelectedValues;
};
